import { DateTime } from "luxon";

/**
 * @important zonedDate MUST be given in wanted timezone!
 *            It depends on stuff like day-of-the week etc,
 *            and this WILL differ across timezones.
 */
export const isBusinessDay = (zonedDate: DateTime) => zonedDate.weekday < 6;
